import type { survey } from './types'
import operationData from '../../data/operationStateData.json'

export class operationService {

  async getOperationStateList(operationType: number): Promise<{ data: survey[] }> {
    const operationTypeList = operationData.data
    if ([2, 4, 6].includes(operationType)) {
      const allowedIds = [1, 4, 5, 6]
      const filtered = operationTypeList.filter((item) => allowedIds.includes(item.id))
      return { data: filtered }
    } else {
      const allowedIds = [1, 2, 3, 4]
      const filtered = operationTypeList.filter((item) => allowedIds.includes(item.id))
      return { data: filtered }
    }
  }
}
